<template>
  <div class="predetermine">
    <div class="predetermine-top">
      <!-- 车辆预订时间 -->
      <van-dropdown-menu>
        <van-dropdown-item
          @change="dropChange"
          v-model="datatiem"
          :options="option1"
        />
        <van-dropdown-item
          @change="dropChange"
          :title="value2"
          v-model="value2"
          :options="option2"
          v-if="isShowTabs !== 'false'"
        />
      </van-dropdown-menu>
    </div>
    <div class="predetermine-nav">
      <!-- 车辆列表 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="nav"
          v-for="(item, index) in list"
          :key="index"
          :title="item"
        >
          <div v-if="isShowTabs == 'false'">
            <div class="font flex mr">
              <div class="flex">
                <div style="margin-right: 20px" class="flex green">
                  <i
                    style="font-size: 0.7rem"
                    class="iconfont icon-car-fill"
                  ></i>
                </div>
                <div class="tabBtnWrapper">
                  <div class="name">
                    公务车{{ convertToChineseNumber(index + 1) }}
                    <div v-if="item.brandType == 1" style="margin-top: 5px">
                      {{ item.carBrand }}
                    </div>
                  </div>
                  <div
                    class="tabBtn"
                    :class="
                      item.useState == '0' ? 'btnColorBule' : 'btnColorGreen'
                    "
                  >
                    <span>{{ item.useState == "1" ? "使用中" : "空闲" }}</span>
                  </div>
                </div>
              </div>
              <div class="btn">
                <van-button
                  @click="toAppointmentCar"
                  :class="item.useState == '1' ? 'btn-l1' : 'btn-l'"
                  size="small"
                  type="default"
                  :disabled="item.useState == '1'"
                  >可预约</van-button
                >
              </div>
            </div>
          </div>
          <div v-if="value2 == '可预约' && isShowTabs !== 'false'">
            <div class="font flex mr">
              <div class="flex">
                <div class="flex">
                  <div style="margin-right: 20px">
                    <img
                      v-if="item.icon"
                      :src="item.icon"
                      alt=""
                      srcset=""
                      style="width: 30px; border-radius: 30px"
                    />
                    <i
                      v-else
                      style="font-size: 0.9rem"
                      class="iconfont icon-geren"
                    ></i>
                  </div>
                  <div>{{ item.driverName }}</div>
                </div>
                <div
                  class="tabBtn"
                  :class="
                    item.useState == '0' ? 'btnColorBule' : 'btnColorGreen'
                  "
                >
                  <span>{{ item.useState == "1" ? "使用中" : "空闲" }}</span>
                </div>
              </div>
              <div class="flex green">
                <div>
                  <i
                    style="font-size: 0.7rem"
                    class="iconfont icon-telephone"
                  ></i>
                </div>
                <div>
                  <a class="green" :href="'tel:' + item.driverPhone">
                    {{ item.driverPhone }}
                  </a>
                </div>
              </div>
            </div>
            <div class="font flex mr">
              <div class="flex">
                <div style="margin-right: 20px" class="flex green">
                  <i
                    style="font-size: 0.7rem"
                    class="iconfont icon-car-fill"
                  ></i>
                </div>
                <div>
                  {{ item.carBrand }}
                </div>
              </div>
              <div class="btn">
                <van-button
                  @click="toAppointmentCar"
                  :class="item.useState == '1' ? 'btn-l1' : 'btn-l'"
                  size="small"
                  type="default"
                  :disabled="item.useState == '1'"
                  >可预约</van-button
                >
              </div>
            </div>
          </div>
          <div v-if="value2 !== '可预约' && isShowTabs !== 'false'">
            <div class="font flex mr">
              <div class="flex">
                <div style="margin-right: 20px" class="flex green">
                  <i
                    style="font-size: 0.7rem"
                    class="iconfont icon-car-fill"
                  ></i>
                </div>
                <div>
                  {{ item.carBrand }}
                </div>
              </div>
              <div>剩余席位：{{ item.remainder }}</div>
            </div>
            <div style="display: flex">
              <span class="have">{{ columns[item.useType - 1] }}</span>
              <span class="complete">使用中</span>
            </div>
            <div class="font flex mr">
              <div>
                {{ item.applyTitle }}
              </div>
              <!-- <div v-show="item.remainder !== 0" class="btn">
                <van-button @click.stop="walkClick(item)" class="btn-r" size="small" type="default">同行</van-button>
              </div> -->
            </div>
            <div class="font mr">
              预计使用时间：{{ comfirmArriveTime(item.useSaterTime) }}
            </div>
            <div class="flex mr">
              <span
                ><i style="font-size: 0.5rem" class="iconfont icon-address"></i
              ></span>
              <div class="address">{{ item.airportName }}</div>
              <span class="line">-</span>
              <span>
                <div
                  v-for="(itemaddress, ind) in item.addressInfoList"
                  :key="ind"
                  class="address1"
                >
                  {{ itemaddress.useLocation }}
                  <!-- <span v-show="item.addressInfoList.length !== ind + 1">-</span> -->
                </div>
              </span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- <van-popup class="popup" v-model="showComfirmOff" position="bottom" :style="{ height: '44%' }">
      <van-form ref="form" style="padding: 10px;">
        <van-field @blur="onBlurpeersNumber" v-model="form.peersNumber" label="同行人数" type="number" placeholder="请输入同行人数"
          required :rules="[{ required: true }]" />
        <van-field v-model="form.peersName" label="姓名" placeholder="请输入同行姓名" required :rules="[{ required: true }]" />
        <van-field v-model="form.peersPhone" label="手机号" placeholder="请输入手机号" required
          :rules="[{ required: true }, tel]" />
        <van-field v-model="form.remarks" rows="3" autosize label="备注" type="textarea" placeholder="请输入备注" />
      </van-form>
      <div class="peopleBtn">
        <van-button @click="cancelOff" type="default" size="small" native-type="button">取消</van-button>
        <van-button class="confirm" size="small" @click="submitOff">确认出发</van-button>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import apis from "@/apis/car.js";
import Vue from "vue";
import { DropdownMenu, DropdownItem } from "vant";
import "@/assets/car/icon/iconfont.css";
import moment from "moment";
import "moment/locale/zh-cn";
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "predetermine",
  props: {},
  components: {},
  data() {
    return {
      tel: {
        // 自定义校验规则
        validator: (value) => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
            value
          );
        },
        message: "请输入正确格式的手机号码",
        trigger: "onBlur",
      },
      datatiem: "",
      option1: [],
      value2: "可预约",
      option2: [
        { text: "可预约", value: "可预约" },
        { text: "使用中", value: "使用中" },
      ],
      show: false,
      currentRow: {},
      list: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      totalAll: 0,
      columns: ["客户接待", "接机", "送机", "供应商考察", "其他"],
      showComfirmOff: false,
      form: {
        applyNumber: "", //申请单号
        peersName: this.$store.state.userInfo.nickname, //同行人姓名
        peersPhone: this.$store.state.userInfo.phone, //电话
        peersNumber: "", // 同行人数
        remainder: "", //剩余人数（该车辆的）
        remarks: "", //备注
      },
      isShowUserId: null,
      isShowTabs: null,
      zoneId: "",
    };
  },
  created() {
    this.option1 = this.getDates();
  },
  mounted() {
    this.isShowTabs = this.$route.query.isShowTabs;
    this.zoneId = this.$route.query.zoneId;
  },
  methods: {
    //格式化时间
    comfirmArriveTime(value) {
      return moment(value).format("MM月DD日 dddd HH:mm");
    },
    //获取车辆预订时间列表，并转换格式
    getDates() {
      const dates = []; // 定义一个存放日期的数组
      for (let i = -6; i <= 6; i++) {
        const date = new Date();
        date.setDate(date.getDate() + i); // 获取前后 6 天的日期
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const value = `${year}-${month}-${day}`; // 格式化日期
        let text = "";

        if (i === 0) {
          text = `${value} 今天`;
          this.datatiem = `${value}`;
        } else if (i === 1) {
          text = `${value} 明天`;
        } else if (i === 2) {
          text = `${value} 后天`;
        } else if (i === -1) {
          text = `${value} 昨天`;
        } else if (i === -2) {
          text = `${value} 前天`;
        } else if (i < 0) {
          text = `${value} ${Math.abs(i)}天前`;
        } else {
          text = `${value} ${i}天后`;
        }

        dates.push({ text: text, value: value }); // 将日期及其描述存到数组中
      }

      return dates; // 返回日期数组
    },
    // getDates() {
    //   const dates = []; //定义一个存放日期的数组
    //   for (let i = 0; i < 7; i++) {
    //     const date = new Date();
    //     date.setDate(date.getDate() + i); //获取今天及后面一周的日期
    //     const year = date.getFullYear();
    //     const month = ("0" + (date.getMonth() + 1)).slice(-2);
    //     const day = ("0" + date.getDate()).slice(-2);
    //     const value = `${year}-${month}-${day}`; //格式化日期
    //     let text = "";
    //     if (i === 0) {
    //       text = `${value} 今天`;
    //       this.datatiem = `${value}`;
    //     } else if (i === 1) {
    //       // 第二个日期是明天
    //       text = `${value} 明天`;
    //     } else if (i === 2) {
    //       text = `${value} 后天`;
    //     } else {
    //       text = `${value} ${i}天后`;
    //     }

    //     dates.push({ text: text, value: value }); //将日期及其描述存到数组中
    //   }

    //   return dates; //返回日期数组
    // },
    // 预约车辆，跳转到预约车辆页面
    toAppointmentCar() {
      this.$router.push({
        path: "/car/official/appointmentCarApply",
        query: {
          isShowUserId: this.$route.query.isShowUserId,
          minDate:this.$route.query.minDate == 'true' ? 'true' : 'false'
        },
      });
    },
    //时间切换
    dropChange() {
      this.list = [];
      this.page = 1;
      this.pageSize = 20;
      this.totalAll = 0;
      this.onLoad();
    },
    //获取车辆预定列表
    onLoad() {
      this.list = [];
      let obj = {
        carState:
          this.isShowTabs == "false"
            ? null
            : this.value2 == "可预约"
            ? "0"
            : "1",
        startTime: this.datatiem,
        endTime: this.datatiem,
        page: this.page,
        pageSize: this.pageSize,
        zoneId: localStorage.getItem("cityId"),
      };
      apis
        .queryBookingCar({ ...obj })
        .then((res) => {
          console.log("车辆预定列表", res.data);
          this.totalAll = res.data.total;
          this.finished = false;
          if (this.page === 1) {
            this.list = res.data.list;
          } else {
            this.list = this.list.concat(res.data.list);
          }
          if (this.list.length < this.totalAll) {
            this.page = this.page + 1;
          } else {
            this.finished = true;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //同行
    walkClick(item) {
      console.log(item);
      this.form.applyNumber = item.applyNumber;
      this.form.remainder = item.remainder;
      this.form.peersNumber = item.remainder;
      this.showComfirmOff = true;
    },
    //输入同行人
    onBlurpeersNumber() {
      if (this.form.peersNumber > this.form.remainder) {
        this.form.peersNumber = this.form.remainder;
      }
    },
    // 取消同行人
    cancelOff() {
      this.form = {
        applyNumber: "", //申请单号
        peersName: this.$store.state.userInfo.nickname, //同行人姓名
        peersPhone: this.$store.state.userInfo.phone, //电话
        peersNumber: "", // 同行人数
        remainder: "", //剩余人数（该车辆的）
        remarks: "", //备注
      };
      this.$refs.form.resetValidation();
      this.showComfirmOff = false;
    },
    // 提交同行人信息
    submitOff() {
      this.$refs.form
        .validate()
        .then(() => {
          console.log("carInfo", this.form);
          let data = {
            applyNumber: this.form.applyNumber,
            peersName: this.form.peersName,
            peersPhone: this.form.peersPhone,
            peersNumber: this.form.peersNumber,
            remainder: this.form.remainder,
            remarks: this.form.remarks,
          };
          console.log(data);
          apis
            .insertPeerInfo(data)
            .then((res) => {
              console.log("确认出发", res);
              if (res.code == "200") {
                this.cancelOff();
                this.dropChange();
              }
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.$toast.fail("提交失败");
        });
    },
    // 数字转换为汉字
    convertToChineseNumber(number) {
      const chineseNumbers = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      const chineseUnit = ["", "十", "百", "千"];

      if (number < 0 || number > 9999) {
        return "超出范围"; // 超出范围，不做转换
      } else if (number === 0) {
        return chineseNumbers[0]; // 处理零的情况
      } else {
        let result = "";
        let numStr = number.toString();
        for (let i = 0; i < numStr.length; i++) {
          let digit = parseInt(numStr[i]);
          if (digit !== 0) {
            result +=
              chineseNumbers[digit] + chineseUnit[numStr.length - i - 1];
          } else {
            // 处理连续的零，只添加一个零
            if (i < numStr.length - 1 && parseInt(numStr[i + 1]) !== 0) {
              result += chineseNumbers[digit];
            }
          }
        }
        return result;
      }
    },
  },
  // 重新调用子组件的onLoad方法
  activated() {
    // this.onLoad()
    this.value2 = "可预约";
    this.option1 = this.getDates();
    this.isShowTabs = this.$route.query.isShowTabs;
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .predetermine {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .predetermine {
    width: 276px * $zoom;
  }
}

.predetermine {
  margin: 1vh auto 0 auto;
  background-color: #f8fafb;

  .predetermine-top {
    width: 100%;

    ::v-deep .van-dropdown-menu__item {
      justify-content: space-between;
      padding-left: 30px;
    }
  }

  .predetermine-nav::-webkit-scrollbar {
    width: 0px;
    height: 7px;
    background-color: #d6d3d32c;
    border-radius: 4px;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  .predetermine-nav::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background-color: #7e7e7e21;
  }

  /*定义滑块 内阴影+圆角*/
  .predetermine-nav::-webkit-scrollbar-thumb {
    border-radius: 3px;
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);
    background-color: #0aa5d496;
  }

  .predetermine-nav {
    height: calc(100vh - 218px);
    overflow-y: auto;
    padding: 0 20px;
    border-radius: 10px;

    &::-webkit-scrollbar {
      display: none;
    }

    .nav {
      margin: 1vh 0;
      padding: 0.3125rem;
      background-color: #fff;

      .mr {
        margin: 20px 0;
      }

      .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .font {
        font-size: 0.35rem;
        font-weight: 600;
        color: #27394e;
      }

      .tabBtnWrapper {
        display: flex;
        align-items: center;
      }

      .tabBtn {
        // width: 106px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin-left: 20px;
        border-radius: 6px;
        padding: 0 10px;
        margin-top: -45px;
        // opacity: 0.1;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }

      .btnColorGreen {
        background-color: #edf5f2;
        color: #4ea27c;
      }

      .btnColorBule {
        background-color: #eaf1fc;
        color: #2c76e3;
      }

      .btn {
        .btn-l {
          margin-left: 20px;
          width: 120px;
          text-align: center;
          color: #fff;
          background-color: #4ea27c;
          border-radius: 10px;
        }

        .btn-l1 {
          margin-left: 20px;
          width: 120px;
          text-align: center;
          color: #fff;
          background-color: #9c9c9c;
          border-radius: 10px;
        }

        .btn-r {
          margin-left: 20px;
          width: 120px;
          text-align: center;
          color: #fff;
          background-color: rgb(255, 142, 32);
          border-radius: 10px;
        }
      }

      .green {
        color: #4ea27c;
      }

      .yellow {
        color: #fe8e20;
      }

      .have {
        background-color: rgb(255 243 232);
        color: rgb(255, 142, 32);
        padding: 5px;
        border-radius: 4px;
        display: inline-block;
        width: 150px;
        text-align: center;
        margin-right: 20px;
        font-size: 26px;
      }

      .complete {
        background-color: rgb(237 245 242);
        color: rgb(81 164 126);
        padding: 5px;
        border-radius: 4px;
        display: inline-block;
        width: 150px;
        text-align: center;
        font-size: 26px;
      }

      .address {
        display: block;
        // width: 90%;
        flex: 1;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.32rem;
        font-weight: 600;
        color: #ccc;
      }

      .address1 {
        display: block;
        width: 330px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.32rem;
        font-weight: 600;
        color: #ccc;
      }

      .line {
        color: #ccc;
        margin: 0 15px;
      }
    }
  }

  .popup {
    ::v-deep .van-field__value {
      background-color: #f7f9fa;
      padding: 10px 20px;
    }

    .peopleBtn {
      margin-top: 30px;
      display: flex;
      justify-content: space-around;

      ::v-deep .van-button--small {
        // height: 86px;
        width: 242px;
        font-size: 28px;
      }

      .confirm {
        background-color: #4ea27c;
        color: #fff;
      }
    }
  }
}
</style>
